<script lang="ts">
  /**
   * Question first, then the answer. The large number sits in a 60px gutter and
   * spans both lines, so the eye finds the section before it reads either.
   *
   * `continuation` is a page that carries on a section in doc view: the number and
   * the question are printed once, where the section starts.
   */
  import EditableText from './EditableText.svelte';
  import type { Section } from './types';

  let {
    section, number, editing = false, agent, continuation = false,
    onheadline, onrevert, oncompare,
  }: {
    section: Section;
    number: number;
    editing?: boolean;
    agent: string;
    continuation?: boolean;
    onheadline?: (text: string) => void;
    onrevert?: () => void;
    oncompare?: () => void;
  } = $props();
</script>

<header class="brf-sec-h" class:cont={continuation}>
  {#if !continuation}
    <span class="brf-sec-n" aria-hidden="true">{number}</span>
    <p class="brf-sec-q">{section.question}</p>
  {/if}
  <h3 class="brf-sec-a">
    {#if continuation}<span>{number}. </span>{/if}<EditableText
      value={section.headline} editing={editing && !continuation}
      ariaLabel="Section {number} answer"
      onchange={(text) => onheadline?.(text)} />{#if continuation}<span
      class="cont">continued</span>{/if}
    {#if section.status === 'edited' || section.status === 'stale'}
      <span class="brf-edmark" contenteditable="false"
        >Edited by {section.edited_by || 'a teammate'}{#if onrevert}<button
          type="button" onclick={onrevert}>Revert</button>{/if}</span>
    {/if}
    {#if section.status === 'stale'}
      <span class="brf-edmark stale" contenteditable="false"
        >{agent} has an update{#if oncompare}<button
          type="button" onclick={oncompare}>Compare</button>{/if}</span>
    {/if}
    {#if section.status === 'error'}
      <span class="brf-edmark err" contenteditable="false">Not generated</span>
    {/if}
  </h3>
</header>
{#if section.note}
  <p class="brf-sec-note" class:evidence={section.note.kind === 'evidence'}>
    {#if section.note.kind !== 'evidence'}<span class="spark" aria-hidden="true">✦</span>{/if}
    <span>{section.note.text}</span>
  </p>
{/if}
